import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useForgotPasswordMutation } from '../../redux/api/userApi';
import MetaData from '../layout/MetaData';
import toast from 'react-hot-toast';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [forgotPassword, { isLoading, error, isSuccess }] = useForgotPasswordMutation();
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) navigate('/');
    if (error) toast.error(error?.data?.message);
    if (isSuccess) toast.success('Recovery instructions sent to your email');
  }, [error, isAuthenticated, isSuccess, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    forgotPassword({ email });
  };

  return (
    <>
      <MetaData title="Forgot Password" />
      <div className="row wrapper">
        <div className="col-10 col-lg-5">
          <form className="shadow rounded bg-body" onSubmit={submitHandler}>
            <h2 className="mb-4 text-center">Forgot Password</h2>
            <p className="text-center text-muted mb-4">
              Enter your email address and we'll send you a link to reset your password.
            </p>

            <div className="mb-3">
              <label htmlFor="email_field" className="form-label">Email Address</label>
              <input
                type="email"
                id="email_field"
                className="form-control"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>

            <button
              id="forgot_password_button"
              type="submit"
              className="btn btn-primary w-100 py-2"
              disabled={isLoading}
            >
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <hr className="my-4" />

            <p className="text-center small text-secondary mb-2">
              <Link to="/login">Back to Login</Link>
            </p>
          </form>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;